import { Card } from "shared/components/Card";
import { Grid } from "shared/components/Grid";
import { GridHeader } from "shared/components/GridHeader";
import { SHOW_ALL, translate } from "shared/utils/translate";
import { useRouter } from "next/router";
import styles from "./CardsContainer.module.css";

export const CardsContainer = ({
  allLinkType,
  items,
  title,
  lead,
  link,
  columns = 3,
  children,
}) => {
  const { locale } = useRouter();
  const hasTitleOrLink = title || allLinkType;

  return (
    <div className={hasTitleOrLink ? styles.withBorder : null}>
      <GridHeader
        title={title}
        lead={lead}
        allLinkType={allLinkType}
        link={link}
      >
        {Boolean(items?.length) && (
          <Grid columns={columns}>
            {(items || []).map(
              ({
                date,
                endDate,
                featured,
                intro,
                overviewImage,
                heroImage,
                slug,
                title,
                _type,
                scope,
                publishedAt,
                properties,
                buttonLabel,
              }) => (
                <Card
                  alt=""
                  date={date}
                  description={intro}
                  endDate={endDate}
                  featured={featured}
                  href={slug?.current}
                  key={title}
                  src={overviewImage || heroImage?.url}
                  title={title}
                  resourceTypes={properties?.resourceTypes}
                  type={_type}
                  scope={scope}
                  publishedAt={publishedAt}
                  buttonLabel={buttonLabel}
                />
              )
            )}
          </Grid>
        )}
        {children}
      </GridHeader>
    </div>
  );
};
